import {Button, Col, Form, Row, Table} from "antd";
import {InputFields, Notification} from "components/common";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import {fields as fieldsInit} from "./config";
import {authenticationService} from "api";
import {isValuable} from "helper/common";
const ModalUser = forwardRef((props: any, ref) => {
  const {record, getListRoleAlina, closeModal} = props;
  const [form] = Form.useForm<{name: string; listRole: any[]}>();
  const [fields, setFields] = useState(fieldsInit);
  useImperativeHandle(ref, () => ({
    resetFields: () => {
      form.resetFields();
    },
  }));
  useEffect(() => {
    const setFieldsValue = record => {
      if (record) {
        form.setFieldsValue(record);
      } else {
        form.resetFields();
      }
    };
    setFieldsValue(record);
  }, [record]);
  useEffect(() => {
    fields.find(e => e.name == "maSso").disabled = isValuable(record);
    setFields([...fields]);
  }, [record]);
  const onSubmit = async () => {
    try {
      const values = {
        id: record?.id,
        ...form.getFieldsValue(),
      };
      let callApi = isValuable(record)
        ? authenticationService.updateRoleAlina
        : authenticationService.postRoleAlina;
      await callApi(values);
      Notification(
        "success",
        `Đã ${record?.id != null ? "cập nhật" : "thêm"} thông tin role`
      );
      closeModal();
      getListRoleAlina();
    } catch (error) {
      Notification("error", "Đã có lỗi");
    }
  };
  return (
    <div>
      <Form form={form}>
        <Row gutter={[4, 4]}>
          <InputFields data={fields}></InputFields>
        </Row>
        <Row justify={"end"} style={{marginTop: 4}}>
          {" "}
          <Button type="primary" onClick={onSubmit}>
            Lưu
          </Button>
        </Row>
      </Form>

      <div></div>
    </div>
  );
});

export default ModalUser;
